import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCollapse,
  CFormSwitch,
  CSmartTable,
} from '@coreui/react-pro'
import { toast } from 'react-toastify'

import moment from 'moment'
import ToastComponent from 'src/components/common/TaostComponent.js'
import RoundService from 'src/service/RoundService'
import EditForm from './EditForm'
import Notify from '../Notify'
import CommonService from 'src/service/CommonService'
const Table = ({
  users,
  setUsers,
  setRoundNumber,
  fetchUsers,
  setActivePage,
  setItemsPerPage,
  setColumnFilter,
  setColumnSorter,
  itemsPerPage,
  activePage,
  columnFilter,
  columnSorter,
  selectedCheckboxes,
  squadFixtureIds,
  toggleAllCheckboxes,
  toggleCheckbox,
}) => {
  const [selectedId, setSelectedId] = useState(0)

  const [loading, setLoading] = useState(false)
  const [visibleHorizontal, setVisibleHorizontal] = useState(false)
  const [details, setDetails] = useState([])
  // Are you sure want modal
  const [handleYes, setHandleYes] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [handleNo, setHandleNo] = useState(false)
  const [tableId, setTableId] = useState(false)

  const handleCancel = () => {
    console.log('You clicked No!')
    return setShowConfirm(false)
  }

  const handleConfirm = () => {
    deleteRound(tableId)
    return setShowConfirm(false)
  }
  const areYouSureModal = (id) => {
    const data = {}
    data.id = id
    data.type = 'round'
    CommonService.checkItemExists(data).then((res) => {
      if (res.status === 200) {
        if (res.data) {
          ToastComponent(res.message, 'error')
        } else {
          setShowConfirm(true)
          setTableId(id)
        }
      }
    })
  }

  const columns = [
    {
      key: 'delete_fixture',
      label: (
        <input
          type="checkbox"
          name="delete_all"
          checked={
            selectedCheckboxes.length === squadFixtureIds.length && squadFixtureIds.length > 0
          }
          onChange={toggleAllCheckboxes}
        />
      ),
      filter: false,
      sorter: false,
    },
    {
      key: 'round',
      _style: { width: '15%' },
      filter: false,
      sorter: false,
    },
    { key: 'start_date', filter: false, sorter: false },
    { label: 'Start Time', key: 'lockout_start_time', filter: false, sorter: false },
    { key: 'end_date', filter: false, sorter: false },
    { label: 'End Time', key: 'lockout_end_time', filter: false, sorter: false },
    { label: 'Restrict Trade', key: 'trade_restriction', filter: false, sorter: true },
    { label: 'Free Trade', key: 'is_free_trades', filter: false, sorter: true },
    {
      key: 'show_details',
      label: 'Action',
      _style: { width: '5%' },
      filter: false,
      sorter: false,
    },
  ]
  const toggleDetails = (index) => {
    setSelectedId(index)
    const position = details.indexOf(index)
    let newDetails = details.slice()
    if (position !== -1) {
      newDetails.splice(position, 1)
    } else {
      newDetails = [...details, index]
    }
    setDetails(newDetails)
  }

  const deleteRound = (id) => {
    setLoading(true)
    const data = {}
    data.id = id
    const position = details.indexOf(id)
    let newDetails = details.slice()
    newDetails.splice(position, 1)
    // setDetails(newDetails)
    RoundService.deleteRound(data).then((res) => {
      if (res.status === 200) {
        fetchUsers()
        toast.dismiss()
        ToastComponent(res.message, 'success')
        setLoading(false)
      }
    })
  }

  useEffect(() => {
    const offset = itemsPerPage * activePage - itemsPerPage
    fetchUsers(offset, itemsPerPage, activePage, columnFilter, columnSorter)
  }, [activePage, columnFilter, columnSorter, itemsPerPage, fetchUsers])

  const updateRestrictAndFreeTradeStatus = (e, id, type) => {
    setLoading(true)
    const data = {}
    data.id = id
    data.value = e.target.checked
    data.type = type
    RoundService.updateRestrictAndFreeTradeStatus(data).then((res) => {
      if (res.status === 200) {
        fetchUsers()
        toast.dismiss()
        ToastComponent(res.message, 'success')
        setLoading(false)
      }
    })
  }

  return (
    <>
      <CSmartTable
        columns={columns}
        columnFilter={{
          external: true,
        }}
        columnSorter={{
          external: true,
        }}
        scopedColumns={{
          delete_fixture: (item) => {
            const fixtureIdExists = squadFixtureIds.some((fixture) => fixture.id === item.id)
            return (
              <th>
                {fixtureIdExists && (
                  <input
                    type="checkbox"
                    name="delete"
                    value={item.id}
                    checked={selectedCheckboxes.includes(item.id)}
                    onChange={() => toggleCheckbox(item.id)}
                  />
                )}
              </th>
            )
          },
          start_date: (item) => <td>{moment(item.start_date).format('D.MM.YYYY')}</td>,
          end_date: (item) => <td>{moment(item.end_date).format('D.MM.YYYY')}</td>,
          lockout_start_time: (item) => <td>{moment(item.start_date).format('h:mm A')}</td>,
          lockout_end_time: (item) => <td>{moment(item.end_date).format('h:mm A')}</td>,
          trade_restriction: (item) => (
            <td>
              <CFormSwitch
                id="trade_restriction"
                label={item?.trade_restriction == 1 ? 'On' : 'Off'}
                checked={item?.trade_restriction}
                onChange={(e) => {
                  updateRestrictAndFreeTradeStatus(e, item.id, 'trade_restriction')
                }}
              />
            </td>
          ),
          is_free_trades: (item) => (
            <td>
              {' '}
              <CFormSwitch
                id="is_free_trades"
                label={item?.is_free_trades == 1 ? 'On' : 'Off'}
                checked={item?.is_free_trades}
                onChange={(e) => {
                  updateRestrictAndFreeTradeStatus(e, item.id, 'is_free_trades')
                }}
              />
            </td>
          ),
          show_details: (item) => {
            return (
              <>
                <td className="py-2">
                  <CButton
                    color="primary"
                    variant="outline"
                    shape="square"
                    size="sm"
                    onClick={() => {
                      toggleDetails(item.id)
                    }}
                  >
                    {details.includes(item.id) ? 'Hide' : 'Manage'}
                  </CButton>
                </td>
              </>
            )
          },
          details: (item) => {
            return (
              <CCollapse visible={details.includes(item.id)}>
                <CCardBody>
                  <CButton
                    size="sm"
                    color="success"
                    className="ml-1"
                    onClick={() => setVisibleHorizontal(!visibleHorizontal)}
                    aria-expanded={visibleHorizontal}
                    aria-controls="collapseEdit"
                  >
                    Edit
                  </CButton>
                  <CButton
                    size="sm"
                    color="danger"
                    className="ml-3"
                    // onClick={() => deleteRound(item.id)}
                    onClick={() => areYouSureModal(item.id)}
                  >
                    Delete
                  </CButton>
                  <CCollapse id="collapseEdit" horizontal visible={visibleHorizontal}>
                    <CCard className="mb-4">
                      <CCardHeader>
                        <strong>Edit Round</strong>
                      </CCardHeader>
                      <CCardBody>
                        <EditForm
                          roundId={item.id}
                          selectedId={selectedId}
                          visibleHorizontal={visibleHorizontal}
                          fetchUsers={fetchUsers}
                          toggleDetails={toggleDetails}
                        />
                      </CCardBody>
                    </CCard>
                  </CCollapse>
                </CCardBody>
              </CCollapse>
            )
          },
        }}
        items={users?.data}
        itemsPerPage={itemsPerPage}
        itemsPerPageSelect
        loading={loading}
        pagination={{
          external: true,
        }}
        paginationProps={{
          activePage: activePage,
          pages: Math.ceil(users?.total / itemsPerPage) || 1,
        }}
        tableProps={{
          hover: true,
          responsive: true,
        }}
        onActivePageChange={(activePage) => setActivePage(activePage)}
        onColumnFilterChange={(filter) => {
          setActivePage(1)
          setColumnFilter(filter)
        }}
        onItemsPerPageChange={(itemsPerPage) => {
          setActivePage(1)
          setItemsPerPage(itemsPerPage)
        }}
        onSorterChange={(sorter) => setColumnSorter(sorter)}
      />
      <Notify
        setShowConfirm={setShowConfirm}
        showConfirm={showConfirm}
        setHandleNo={setHandleNo}
        handleNo={handleNo}
        handleYes={handleYes}
        setHandleYes={setHandleYes}
        handleConfirm={handleConfirm}
        handleCancel={handleCancel}
        text="Are you sure you want to delete this?"
      />
    </>
  )
}

export default Table
